import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";


const Wrapper = styled.div`
  height: 50vh;
  background-color: #f3f2eaff;
  display: flex;
  flex-direction: column;
  @media (min-width: 1024px) {
    height: 100dvh;
  }
`;

const Title = styled.div`
  font-family: NonNaturalGrotesk;
  font-size: 20px;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: subpixel-antialiased;
  text-transform: uppercase;
  letter-spacing: 3px;

  h1 {
      margin: 0 0 40px;
      line-height: 1;
      color: #3D3D3D;
  }

  span:nth-of-type(2) {
    color: #6A8CAF;
    margin-left: 10px;
  }

  @media (min-width: 1024px) {
    font-size: 5vw;
  }
`;

const Text = styled.div`
  padding: 0 15px 50px;
  margin: 200px 0 0;

  @media (min-width: 1024px) {
    padding: 0 60px 100px;
    margin: auto 0 0;
  }
`;

const Subtitle = styled.div`
  width: fit-content;
  font-size: 16px;
  text-transform: uppercase;
  line-height: 1.2;
  color: #3D3D3D;
  z-index:2;
  p {
    font-family: NonNaturalGrotesk;
  }

    @media (min-width: 1024px) {
      margin-left: 20px;
      font-size: 22px;
  }
`;

const Header = () => {
const { t, i18n } = useTranslation();

  return (
      <Wrapper>
      <Text>
        <Title data-scroll data-scroll-speed="2">
          <h1><span>Aurelie Plane</span>
          <span class="dot">.</span>
          </h1>
        </Title>
               <Subtitle>
            <p>{t("subtitle")} </p>
        </Subtitle>
        </Text>
      </Wrapper>
  );
};

export default Header;
